module.exports = __webpack_public_path__ + "static/media/jen-art-site.729fbd60.jpg";